import React from 'react';
import * as PropTypes from 'prop-types';
import Section from '@/yema-designkit/webkit/layouts/Section';

const Title = ({ children, isH1, className }) => {
    return isH1 ? (
        <h1 className={className}>{children}</h1>
    ) : (
        <h2 className={className}>{children}</h2>
    );
};

const CMS_BodyTitle = ({ content }) => {
    if (typeof content === 'string')
        return (
            <Section className='bg-[#f7f5f1]'>
                <div className='container-fluid'>
                    <div className='row'>
                        <div className='rich-text w-full'>
                            <h1>{content}</h1>
                        </div>
                    </div>
                </div>
            </Section>
        );

    let { title, is_h1 } = content;
    return (
        <Section className='bg-[#f7f5f1]'>
            <div className='container-fluid'>
                <div className='row'>
                    <div className='rich-text w-full'>
                        <Title isH1={is_h1}>{title}</Title>
                    </div>
                </div>
            </div>
        </Section>
    );
};

CMS_BodyTitle.propTypes = {
    content: PropTypes.oneOfType([
        PropTypes.string,
        PropTypes.shape({
            title: PropTypes.string,
            is_h1: PropTypes.bool,
        }),
    ]).isRequired,
};

export default CMS_BodyTitle;
